import { Locale } from '@cars4ever/public-ui';

import TBasicTexts from '../types/TBasicTexts';

import danish from './danish';
import swedish from './swedish';

const basicTexts: Record<Locale, TBasicTexts> = {
  [Locale.DK]: danish,
  [Locale.SE]: swedish,
};

export default basicTexts;
